import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { alpha, darken } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
const Wrapper = styled('div')(({
  theme: {
    spacing,
    radius
  }
}) => ({
  padding: spacing(2),
  maxWidth: 1280,
  borderRadius: radius.banner
}));
export interface PartTitleProps {
  number: number;
  color: string;
  children: ReactNode;
  component?: any;
  id: string;
}
const PartTitle = t0 => {
  const $ = _c(21);
  const {
    number,
    color,
    children,
    component: t1,
    id
  } = t0;
  const component = t1 === undefined ? "h3" : t1;
  const t2 = `part-${id}`;
  let t3;
  if ($[0] !== color) {
    t3 = alpha(color, 0.08);
    $[0] = color;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== color || $[3] !== t3) {
    t4 = {
      color,
      backgroundColor: t3
    };
    $[2] = color;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      lineHeight: 1
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== color) {
    t6 = darken(color, 0.2);
    $[6] = color;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== number) {
    t7 = translate("course_toc.part", {
      part_number: number
    });
    $[8] = number;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <Typography sx={t5} color={t6} variant="overline" component="div">{t7}</Typography>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== children || $[14] !== component) {
    t9 = <Typography color="textPrimary" variant="h6" component={component}>{children}</Typography>;
    $[13] = children;
    $[14] = component;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t2 || $[17] !== t4 || $[18] !== t8 || $[19] !== t9) {
    t10 = <Wrapper id={t2} sx={t4}>{t8}{t9}</Wrapper>;
    $[16] = t2;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default PartTitle;